export default {"src":"/_next/static/media/chatbot-sv.e3a70589.svg","height":199,"width":409,"blurWidth":0,"blurHeight":0};